/**
 * @voltxampere/web — `<vxa-sidebar>` container (Sprint 11).
 *
 * Pinned search at the top, scrollable content below. The
 * scroll region holds the 4-section component library and
 * the templates placeholder.
 *
 * Copyright © 2026 360 Studio
 * Proprietary — All rights reserved.
 */

import { LitElement, html, css } from "lit";
import { customElement } from "lit/decorators.js";

import "./vxa-search.js";
import "./vxa-component-library.js";
import "./vxa-templates.js";

@customElement("vxa-sidebar")
export class VxaSidebar extends LitElement {
  static override styles = css`
    :host {
      display: flex;
      flex-direction: column;
      height: 100%;
      overflow: hidden;
    }

    .scroll {
      flex: 1;
      overflow-y: auto;
      padding: var(--s-4);
    }
  `;

  override render() {
    return html`
      <vxa-search></vxa-search>
      <div class="scroll">
        <vxa-component-library></vxa-component-library>
        <vxa-templates></vxa-templates>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "vxa-sidebar": VxaSidebar;
  }
}
